module.exports = __webpack_public_path__ + "static/img/17.76c8405.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/17.png
// module id = l83W
// module chunks = 5